import { apiAnalytics } from "@utils/api";
import {
	UserEventDTO,
	UserLoginEventDTO,
	UserLoginPageDTO,
} from "@utils/api/analytics/user-event.dto";

// apiAnalytics 的 response interceptor 會 return res.data，型別在這裡修正回實際內容
export interface LoginEventResponse {
	jwt?: string;
}

export namespace UserEventApi {
	export async function loginEvent(
		data: UserLoginEventDTO,
	): Promise<LoginEventResponse> {
		return apiAnalytics.post(
			"/liff/login",
			data,
		) as unknown as Promise<LoginEventResponse>;
	}

	export async function logEvent(data: UserEventDTO) {
		return apiAnalytics.post("/log/event", data);
	}

	export async function logPage(data: UserLoginPageDTO) {
		return apiAnalytics.post("/log/page", data);
	}
}
